module.exports = __webpack_public_path__ + "img/2.4_Students-Trainees_2_Ambrose.d761c6a8166717a80190dc73778bedc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.4_Students-Trainees_2_Ambrose.png
// module id = 764
// module chunks = 0